//Sticky menu functions
export default class StickyMenu {
    stickyMenu;
    stickyHamburger;
    stickyOuter;
    stickyInner;
    constructor() {
        this.stickyMenu = document.querySelector('.js-sticky-menu');
        if (!this.stickyMenu)
            return;
        this.stickyHamburger = this.stickyMenu.querySelector('.js-sticky-hamburger');
        this.stickyOuter = this.stickyMenu.querySelector('.js-sticky-outer');
        this.stickyInner = this.stickyMenu.querySelector('.js-sticky-inner');
        this.stickyHamburger.addEventListener('click', () => this.stickyMenuFunc());
    }
    stickyMenuFunc() {
        if (this.stickyMenu.classList.contains('sticky-menu-open')) {
            this.stickyMenu.classList.remove('sticky-menu-open');
            Object.assign(this.stickyOuter.style, {
                height: `0px`,
            });
            return;
        }
        Object.assign(this.stickyOuter.style, {
            height: `${this.stickyInner.offsetHeight}px`,
        });
        this.stickyMenu.classList.add('sticky-menu-open');
    }
}
